<template>
  <section id="content">
    <PageTitle :title="$t('tools.companies.title')"></PageTitle>
    <div class="wrapper wrapper-content animated fadeInRight">

      <div class="row">
        <div class="col-lg-12">
          <VatValidation></VatValidation>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <SirenValidation></SirenValidation>
        </div>
      </div>
    

      <div class="row">
          <div class="col-lg-12">
            <CompanySearch></CompanySearch>
          </div>
      </div>

    </div>

  </section>
</template>

<style scoped>
  
</style>


<script lang="ts">
import { Component, Watch } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';
import PageTitle from '../../panels/PageTitle.vue';
import VatValidation from '../../panels/tools/VatValidation.vue';
import SirenValidation from '../../panels/tools/SirenValidation.vue';
import CompanySearch from '../../panels/tools/CompanySearch.vue';

@Component({
  components: {
    PageTitle,
    VatValidation,
    SirenValidation,
    CompanySearch
  }
})
export default class Companies extends mixins(GenericPage) {

}
</script>